module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="coming-soon">\n	<div class="text-block">\n		<h5>Trying to sneak a peek at your opponent’s team? Once round 1 is over, and all of your leagues’ teams are locked in, and lockout has been lifted, you’ll be able to view all matchups from there on out.</h5>\n	</div>\n</div>\n';
}
return __p;
};
